import { useState } from 'react';

import { useSessionStore } from '@/entities/session';
import { RADIUS, Squircle } from '@/shared/ui';

import styles from './WelcomeModal.module.scss';

/**
 * Приветствие при первом входе (узел 440:58699/440:58997).
 *
 * Во весь экран, без затемнения фона — так в макете: панель сама
 * закрывает хэдер, карточки и нижний бар, а не всплывает поверх них.
 * Поэтому монтируется в AppLayout (см. AppLayout.tsx), а не в RequireAuth —
 * `position: absolute` должен считаться от отмасштабированного холста
 * 390×902 (`.layout`), а не от реального окна браузера.
 *
 * `isNewUser` не персистится (только токен, см. session.store.ts) — при
 * обычной перезагрузке страницы стор поднимается заново и флаг снова
 * `false`, поэтому «закрыл один раз — больше не увидит» достаточно
 * локального состояния компонента, без похода в стор или на сервер.
 */
export function WelcomeModal() {
  const isNewUser = useSessionStore((state) => state.isNewUser);
  const [dismissed, setDismissed] = useState(false);

  if (!isNewUser || dismissed) return null;

  const close = (): void => {
    setDismissed(true);
  };

  return (
    <div className={styles.sheet} data-testid="welcome-modal">
      <img className={styles.shapeBg} src="/images/welcome/shape-bg.svg" alt="" aria-hidden />
      <img className={styles.hero} src="/images/welcome/hero.png" alt="" aria-hidden />

      <button type="button" className={styles.close} aria-label="Закрыть" onClick={close}>
        <img className={styles.closeIcon} src="/images/matches/close-light.svg" alt="" aria-hidden />
      </button>

      <div className={styles.content}>
        <div className={styles.text}>
          <h2 className={styles.title}>Путь чемпиона BETBOOM</h2>
          <p className={styles.body}>
            Какой клуб возьмёт ЛЧ? Делай прогнозы, показывай активность
            в Телеграм-канале <strong className={styles.accent}>BETBOOM</strong>{' '}
            и получай призы!
            <br />
            <br />
            {/* Неразрывный пробел: иначе «100 000» рвётся по строкам */}
            Каждый месяц разыгрываем фрибеты на 100&nbsp;000 и другие крутые
            призы.
            Главный трофей сезона —{' '}
            <strong className={styles.accent}>
              путешествие в город победителя ЛЧ
            </strong>
          </p>
        </div>

        <Squircle asChild cornerRadius={RADIUS.xl}>
          <button type="button" className={styles.cta} onClick={close} data-testid="welcome-modal-cta">
            Понял!
          </button>
        </Squircle>
      </div>
    </div>
  );
}
